@if (user?.User) {
  <div class="user-main" [title]="user.User.FirstName + ' ' + user.User.LastName" (click)="openUserDetail()">
    <img [src]="user.User.AvatarURL" alt="Avatar" class="user-avatar">
    <span class="user-main-info">
      <span class="user-name">
        <span class="value">{{user.User.FirstName + ' ' + user.User.LastName}}</span>
        <span class="value invisible">{{user.User.FirstName + ' ' + user.User.LastName}}</span>
      </span>
      <span class="position-user-mobile">{{user.User.Organisation}}</span>
    </span>
  </div>
  <div class="user-email" [title]="user.User.Email"  (click)="openUserDetail()">
    <span class="value">{{user.User.Email}}</span>
    <span class="value invisible">{{user.User.Email}}</span>
  </div>
  <div class="user-position" [title]="user.User.Login" (click)="openUserDetail()">
    <span class="value">{{user.User.Login}}</span>
    <span class="value invisible">{{user.User.Login}}</span>
  </div>
  <div class="user-role" [title]="userRoles"  (click)="openUserDetail()">
    <span class="value">{{userRoles}}</span>
    <span class="value invisible">{{userRoles}}</span>
  </div>
  <div class="user-last-login padding" (click)="openUserDetail()">
    <span class="value">{{ date }}</span>
    <span class="value invisible">{{ date }}</span>
  </div>
  @if (isCloudUser) {
    <div class="user-last-login center">
      <div class="column" [style.visibility]="hideToggle ? 'hidden' : ''">
        <div class="toggle-btn" (click)="deactivateUser()">
          <fi-switch [checked]="activated"
            [class.true]="activated"
            [class.false]="!activated">
          </fi-switch>
          @if (!activated && user?.Data?.DEACTIVATEDOBJECTTYPEID?.Value) {
            <span class="ticket-id">{{ user?.Data?.DEACTIVATEDOBJECTTYPEID?.Value }}</span>
          }
        </div>
      </div>
    </div>
  }
}
